import { render, staticRenderFns } from "./DefaultCaption.vue?vue&type=template&id=6a52e396&"
import script from "./DefaultCaption.vue?vue&type=script&lang=ts&"
export * from "./DefaultCaption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports